export function UnlockIcon() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 0C23.28 0 30 6.72 30 15C30 23.28 23.28 30 15 30C6.72 30 0 23.28 0 15C0 6.72 6.72 0 15 0Z"
        fill="#75CF00"
      />
      <path
        d="M17.7998 13.8499H12.5398V10.6999C12.5398 9.33992 13.6498 8.22992 15.0098 8.22992C16.3698 8.22992 17.4798 9.33992 17.4798 10.6999H18.7898C18.7898 8.61992 17.0998 6.91992 15.0098 6.91992C12.9198 6.91992 11.2298 8.60992 11.2298 10.6999V14.0999C10.5598 14.4499 10.0898 15.1499 10.0898 15.9599V19.2799C10.0898 20.4499 11.0398 21.3999 12.1998 21.3999H17.7998C18.9698 21.3999 19.9198 20.4499 19.9198 19.2799V15.9599C19.9198 14.7899 18.9698 13.8499 17.7998 13.8499ZM15.5498 17.9299V19.2999C15.5498 19.6099 15.2998 19.8599 14.9898 19.8599C14.6798 19.8599 14.4298 19.6199 14.4298 19.2999V17.9299C13.9698 17.7199 13.6498 17.2599 13.6498 16.7199C13.6498 15.9899 14.2398 15.3899 14.9798 15.3899C15.7198 15.3899 16.3098 15.9899 16.3098 16.7199C16.3098 17.2599 15.9898 17.7199 15.5298 17.9299H15.5498Z"
        fill="#FFFDFE"
      />
    </svg>
  )
}

export function BellIcon() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 0C23.28 0 30 6.72 30 15C30 23.28 23.28 30 15 30C6.72 30 0 23.28 0 15C0 6.72 6.72 0 15 0Z"
        fill="#00C238"
      />
      <path
        d="M20.2498 17.14L11.4698 18.91C11.1598 18.97 10.8698 18.75 10.8498 18.44C10.7498 17.21 11.0998 16.02 11.7898 15.08L11.3098 12.72C10.9398 10.87 12.1298 9.06997 13.9798 8.69997C15.8298 8.32997 17.6298 9.51997 17.9998 11.37L18.4798 13.73C19.4798 14.34 20.2598 15.3 20.6498 16.47C20.7498 16.77 20.5598 17.08 20.2598 17.15L20.2498 17.14Z"
        fill="#FDFDFD"
      />
      <path
        d="M13.0498 19.7501L16.3598 19.0801C16.5398 19.9901 15.9498 20.8901 15.0398 21.0701C14.1298 21.2501 13.2298 20.6601 13.0498 19.7501Z"
        fill="#FDFDFD"
      />
    </svg>
  )
}

export function StarIcon() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 0C23.28 0 30 6.72 30 15C30 23.28 23.28 30 15 30C6.72 30 0 23.28 0 15C0 6.72 6.72 0 15 0Z"
        fill="#00ACEB"
      />
      <path
        d="M15.0002 19.2L12.0102 21.37C11.2602 21.91 10.2502 21.18 10.5402 20.3L11.6802 16.79L8.69021 14.62C7.94021 14.08 8.33021 12.89 9.25021 12.89H12.9402L14.0802 9.37997C14.3702 8.49997 15.6102 8.49997 15.9002 9.37997L17.0402 12.89H20.7302C21.6602 12.89 22.0402 14.07 21.2902 14.62L18.3002 16.79L19.4402 20.3C19.7302 21.18 18.7202 21.91 17.9702 21.37L14.9802 19.2H15.0002Z"
        fill="white"
      />
    </svg>
  )
}

export function BackArrowIcon() {
  return (
    <svg
      width="37"
      height="36"
      viewBox="0 0 37 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <rect
          x="0.75"
          y="0.75"
          width="35.5"
          height="34.5"
          rx="17.25"
          fill="white"
          fillOpacity="0.56"
        />
        <rect
          x="0.75"
          y="0.75"
          width="35.5"
          height="34.5"
          rx="17.25"
          fill="#2C2C2C"
          style={{ mixBlendMode: 'color-dodge' }}
        />
        <rect
          x="0.75"
          y="0.75"
          width="35.5"
          height="34.5"
          rx="17.25"
          stroke="url(#paint0_linear_350_2825)"
          strokeWidth="1.5"
        />
        <path
          d="M20.2143 23.0401L16.0229 18.8487C15.5279 18.3537 15.5279 17.5437 16.0229 17.0487L20.2143 12.8572"
          stroke="#333333"
          strokeWidth="1.3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_350_2825"
          x1="19.811"
          y1="-6.75551e-07"
          x2="29.7414"
          y2="33.0129"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.3" />
          <stop offset="1" stopColor="white" stopOpacity="0.1" />
        </linearGradient>
      </defs>
    </svg>
  )
}
